/**
 * Floor Plan Lot Status Service
 *
 * A floor plan candidate's lot status for redux/selectors.js#selectSimilarHomesCandidates
 * (NHS20-8827) — null unless every eligible lot it's buildable on shares the same status.
 * Usually null: a plan buildable on several Available lots has no single status of its own
 * worth reporting. But NHS20-9003: a plan buildable on exactly one lot that happens to be Model
 * must read as "Model home" rather than the generic "Floor plan" label — the "Model lots never
 * carry housePlanIds" assumption documented in services/processCommunityMap.js's
 * mutually-exclusive-fields note does not hold in every case. Pure data derivation — no
 * Redux/DOM knowledge — mirrors services/soldHomeSortService.js's role for
 * redux/selectors.js#selectSoldHomes.
 *
 * @module nativeInteractiveSiteMap/services/floorPlanLotStatusService
 */

/**
 * @param {{ lotIds: number[] }} plan - selectHousePlans entry.
 * @param {Record<string, { status: string }>} lotsById
 * @param {Set<number>} eligibleLotIds
 * @returns {string|null}
 */
export default function deriveFloorPlanLotStatus(plan, lotsById, eligibleLotIds) {
  const eligibleStatuses = new Set(
    plan.lotIds
      .filter((lotId) => eligibleLotIds.has(lotId))
      .map((lotId) => lotsById[lotId]?.status)
  );
  return eligibleStatuses.size === 1 ? [...eligibleStatuses][0] : null;
}
